import { SelectorData } from './selectorDataType';

export enum Roles {
  GLOBAL_ADMIN = 'GLOBAL_ADMIN',
  REGIONAL_ADMIN = 'REGIONAL_ADMIN',
  VIEW_ADMIN = 'VIEW_ADMIN',
  CALL_CENTER_AGENT = 'CALL_CENTER_AGENT',
}

// TODO reimplement as enum for screen usage.
export const selectableRoles: SelectorData[] = [
  { label: 'Global', value: Roles.GLOBAL_ADMIN },
  { label: 'Regional', value: Roles.REGIONAL_ADMIN },
  { label: 'View Only', value: Roles.VIEW_ADMIN },
  { label: 'Call Center Agent', value: Roles.CALL_CENTER_AGENT },
];
